import { Provider, ProviderToken } from '@angular/core';
import { ShareableType } from '@bindoc-projects/resource-domain-lib';
import { RESOURCE_REGISTRATION } from './token';

/** Register service tokens without constructing services or duplicating their identity. */
export function provideResourceRegistrations(
  resourceService: ProviderToken<unknown>,
  ...resourceNames: ShareableType[]
): Provider[] {
  return resourceNames.map((resourceName) => ({
    provide: RESOURCE_REGISTRATION,
    multi: true,
    useValue: { resourceName, resourceService },
  }));
}
